import { Environment } from "models/environment/Environment";

export const environment: Environment = {
    production: true,
    backendUrl: "api",
    msApplicationId: "df0605be-d410-4a09-b205-24511cb40f11",
    desktop: false,
};
